import React, { CSSProperties, Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Card, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row } from 'react-bootstrap';
import { ResultOperation, Column, SelfTableList, FilterState, ListFields, usePermission, useTranslation, useFetch } from '@np/np_webcomponentlib'
import { API_BUSINESS, API_OPERATIONS_VIEW } from '../../shared/consts/api'


import { ColumnEvent, ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'
import { TypeOperationEnum, TypePaymentMethodEnum, optionsEnumTypeOperation, optionsEnumTypePaymentMethod } from '../../shared/MasterData/MasterDataTypes';
import TypeOperationCheckboxList from '../../shared/MasterData/TypeOperationCheckboxList';

import { DataEntityType as BusinessType } from '../Business/BusinessTypes'

import { DataEntityType as RFRateType } from '../Rate/RateTypes'
import { useNavigate } from 'react-router-dom';
import { formatAmount } from '../../shared/utils/formatAmount';
import Select from 'react-select';
import CurrencyInput from 'react-currency-input-field';

import { format } from 'date-fns';

interface DRProvider {
  business: BusinessType;
  idrfRate: string;
  typeOperation: string;
  paymentMethod: string;
  bank: string;
  comissionPercent: number;
  minimumComission: number;
  minAmountPayment: number;
  maxAmountPayment: number;
  comments: string;
  idUnique: string;
  dateAdded: Date;
  dateUpdated: Date;
  dateSoftRemoved: Date;
  dateUpdateRG: Date;
  rate: RFRateType;
  idCurrencyBalance: string;
  idCurrencyPayment: string;
  idBusiness: string;
  providerURLHost: string;
}


interface EntityData {
  requestDurationMillisecond: number;
  listProvidersRate: [DRProvider];
}

const SmartSorted = ({ idBusiness }: { idBusiness: string }) => {


  const [entityProviders, setEntityProviders] = useState<EntityData>()

  const [typeOperation, setTypeOperation] = useState<TypeOperationEnum>(TypeOperationEnum.PayIn)
  const [typePaymentMethod, setTypePaymentMethod] = useState<TypePaymentMethodEnum>(TypePaymentMethodEnum.toCard)
  const [amount, setAmount] = useState<number>(2000)




  const [, doFetchLoad] = useFetch(
    `${API_BUSINESS}business/ratedata/view`)//{ error: errCU, isLoading: isLoadCU, response: respCU }


  useEffect(() => {

    doFetchLoad({
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      data: {
        idBusiness: idBusiness,
        typeOperation: typeOperation,
        typePaymentMethod: typePaymentMethod,
        amount: amount,
        listBanks: [],
        listBanksNotContains: []
      }
    }).then(responce => {
      setEntityProviders(responce.data)
      console.log(responce.data)
    })


  }, [typeOperation, typePaymentMethod, amount])

  const [className, setClassName] = useState('');
  const [value, setValue] = useState<string | number>('');

  const validateValue = (_value, name, _values): void => {
    setValue(_value);
    setAmount(isNaN(_values.float) ? 0 : _values.float);
  };

  return (
    <Fragment>

      <h2>Сортировка провайдеров</h2>

      <Card>
        <Card.Header>
          <Card.Title as='h4'>{useTranslation('generateReport')}</Card.Title>
        </Card.Header>
        <Card.Body className="">
          {/* <Form className="form-horizontal"> */}

          <Row className="mb-4">
            <Form.Label className="col-md-3">{useTranslation('typeBusiness')}</Form.Label>
            <Col md={9}>
              <Select options={optionsEnumTypeOperation} placeholder='choose one' classNamePrefix='Select' value={optionsEnumTypeOperation.find(option => option.value === typeOperation) ?? optionsEnumTypeOperation[0]}
                onChange={e => setTypeOperation(e?.value!)}
                />
            </Col>
          </Row>

          <Row className="mb-4">
            <Form.Label className="col-md-3">{useTranslation('typeBusiness')}</Form.Label>
            <Col md={9}>
              <Select options={optionsEnumTypePaymentMethod} placeholder='choose one' classNamePrefix='Select' value={optionsEnumTypePaymentMethod.find(option => option.value === typePaymentMethod) ?? optionsEnumTypePaymentMethod[0]}
                onChange={e => setTypePaymentMethod(e?.value!)}
                />
            </Col>
          </Row>

          <Row className="mb-4">
            <Form.Label className="col-md-3">Для суммы</Form.Label>
            <Col md={9}>
              <CurrencyInput
                id="validationCustom01"
                name="input-1"
                className={`form-control ${className}`}
                value={value}
                onValueChange={validateValue}
                placeholder="Для суммы"
                prefix={''}
                decimalScale={2}
                step={1}
                groupSeparator={' '}
              />
            </Col>
          </Row>

        </Card.Body>
      </Card>

      <h2 style={{ marginTop: "50px", marginBottom: "50px" }}>Провайдеры</h2>

      <h3>Время выполнения: {entityProviders?.requestDurationMillisecond}</h3>

      {entityProviders?.listProvidersRate &&
        <TableData titleFirstColumn="Провайдер" entity={entityProviders?.listProvidersRate}></TableData>
      }

    </Fragment>
  )
}

export default SmartSorted

const TableData = ({ titleFirstColumn, entity }: { titleFirstColumn: string, entity: DRProvider[] }) => {
  const navigate = useNavigate()

  const fixedColumnStyle: CSSProperties = {
    width: "300px",
    whiteSpace: "normal",
    wordWrap: "break-word",
    wordBreak: "break-word",
    textAlign: "center"
  };

  return <table className="table table-bordered text-nowrap mb-0">

    <thead>
      <tr>
        <th style={fixedColumnStyle}>
          {titleFirstColumn}
        </th>
        <th>Комиссия</th>
        <th>Обновлено</th>


      </tr>
    </thead>

    <tbody>
      {entity && entity.length > 0 ? (
        entity.map((item, index) => (
          <tr key={index}>
            <td style={fixedColumnStyle}><div onClick={() => navigate("/business/" + item.business.idUnique)}>
              {item.business?.name}
            </div></td>
            <td>{formatAmount(item.comissionPercent)}</td>
            <td>{format(item.dateUpdateRG, 'dd-MM-yyyy HH:mm:ss')}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={7} className="text-center">
            Данные не найдены
          </td>
        </tr>
      )}

    </tbody>

  </table>;
}
